export const headerHeight = 72;
export const bannerHeight = 66;



// WEBPACK FOOTER //
// ./app/constants/elementHeight.js